/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import _, { filter } from 'lodash';
import { toast } from 'react-toastify';
import {
  getTeamFilter,
  getHeadFilter,
  getManagerFilter,
  getRepFilter,
  getSpecialtyFilter,
} from '../../../api/filterOptionsApi';
// Helpers
import {
  filterValue,
  filterMultiValue,
  filterTeamOptions,
  filterHeadOptions,
  filterManagerOptions,
  filterRepOptions,
  filterSpecialtyOptions,
} from '../../../helpers/filterFunctions';

import { getAgendaFilter } from '../../../api/dropdownOptionsApi';
import useSalesWeeklyReportContext from '../context/useSalesWeeklyReportContext';

function Filter() {
  const { filterForm, setFilterForm, handleGenerateReport, handleClearReport } = useContext(
    useSalesWeeklyReportContext,
  );

  const [teamOptions, setTeamOptions] = useState([]);
  const [headOptions, setHeadOptions] = useState([]);
  const [managerOptions, setManagerOptions] = useState([]);
  const [repOptions, setRepOptions] = useState([]);
  const [agendaOptions, setAgendaOptions] = useState([]);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);

  const loadTeamDropdown = async () => {
    const request = {
      head_id: filterValue(filterForm?.head_id),
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
      specialties: filterMultiValue(filterForm?.specialty),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const reponse = await getTeamFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterTeamOptions(data);
      setTeamOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadHeadDropdown = async () => {
    const request = {
      team: filterValue(filterForm?.team),
      head_id: filterValue(filterForm?.head_id),
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
      specialties: filterMultiValue(filterForm?.specialty),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const response = await getHeadFilter(request);
    const { code, data } = response.data;

    if (code === '200') {
      const dropdownValue = filterHeadOptions(data);
      setHeadOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadManagersDropdown = async () => {
    const request = {
      team: filterValue(filterForm?.team),
      head_id: filterValue(filterForm?.head_id),
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
      specialties: filterMultiValue(filterForm?.specialty),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const response = await getManagerFilter(request);
    const { code, data } = response.data;

    if (code === '200') {
      const dropdownValue = filterManagerOptions(data);
      setManagerOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadRepDropdown = async () => {
    const request = {
      team: filterValue(filterForm?.team),
      head_id: filterValue(filterForm?.head_id),
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
      specialties: filterMultiValue(filterForm?.specialty),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const reponse = await getRepFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);
      setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadAgendaDropdown = async () => {
    const request = {
      keyword: '',
    };
    const reponse = await getAgendaFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.description,
        label: row.description,
      }));

      setAgendaOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadSpecialtyDropdown = async () => {
    const request = {
      team: filterValue(filterForm?.team),
      head_id: filterValue(filterForm?.head_id),
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
      date_from: moment(filterForm?.from).format('YYYY-MM-DD'),
      date_to: moment(filterForm?.to).format('YYYY-MM-DD'),
    };
    const reponse = await getSpecialtyFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterSpecialtyOptions(data);

      setSpecialtyOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeDate = (label, value) => {
    setFilterForm({ ...filterForm, [label]: moment(value).format('YYYY-MM-DD') });
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };
  useEffect(() => {
    loadTeamDropdown();
    loadHeadDropdown();
    loadManagersDropdown();
    loadRepDropdown();
    loadAgendaDropdown();
    loadSpecialtyDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='team'
            disableClearable
            fullWidth
            options={teamOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Teams' />}
            size='small'
            value={filterForm?.team}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'team')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='head_id'
            disableClearable
            fullWidth
            options={headOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='RMPM' />}
            size='small'
            value={filterForm?.head_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'head_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='manager_id'
            disableClearable
            fullWidth
            options={managerOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='DMPM' />}
            size='small'
            value={filterForm?.manager_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'manager_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MPR' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            id='agenda'
            multiple
            fullWidth
            filterOptions={(x) => x}
            options={agendaOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm?.agenda}
            noOptionsText='No Agendas'
            onChange={(e, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [agendaOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [agendaOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== agendaOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                agenda: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Agenda' />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            id='specialty'
            multiple
            fullWidth
            filterOptions={(x) => x}
            options={specialtyOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm?.specialty}
            noOptionsText='No Specialty'
            onChange={(e, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [specialtyOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [specialtyOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== specialtyOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                specialty: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Specialty' />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date From'
            inputFormat='MM/DD/YYYY'
            value={filterForm?.from}
            onChange={(e) => handleChangeDate('from', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={1}>
          <DesktopDatePicker
            label='Date To'
            inputFormat='MM/DD/YYYY'
            value={filterForm?.to}
            fullWidth
            onChange={(e) => handleChangeDate('to', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateReport}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleClearReport}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
